import React, { useState } from 'react';
import { makeStyles } from "@mui/styles";
import {Menu, MenuItem, Button, Paper} from '@mui/material'
import { useTranslation } from 'react-i18next';
import PublIcon from '@mui/icons-material/Public';

export default function SettingsPage(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation();

    const handleLanguageChange = (newlang) => {
        props.i18n.changeLanguage(newlang);
        setAnchorEl(null);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    return <div className="background">
        <div className={classes.spacer80}></div>
        <Paper className={classes.paper}>
            <div className="translationContainer">
                <Button
                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    className="languageButton"
                >
                    <PublIcon></PublIcon>
                    {t('Language')}
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}>
                    <MenuItem onClick={() => handleLanguageChange('nl')}>{t('Dutch')}</MenuItem>
                    <MenuItem onClick={() => handleLanguageChange('en')}>{t('English')}</MenuItem>
                    <MenuItem onClick={() => handleLanguageChange('fr')}>{t('French')}</MenuItem>
                </Menu>
            </div>
        </Paper>
    </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },

    paper: {
        padding: '50px',
        margin: "50px",
        height: '70%'
    }
});